const getTripsWithIdField = (initialTrips, defaultTrips) => {
  if (initialTrips) {
    return initialTrips.map(trip => ({
      ...trip,
      id: trip.id,
      bookingClass: [],
    }));
  }

  return defaultTrips;
};

export default getTripsWithIdField;
